// extracted by mini-css-extract-plugin
module.exports = {"fullTableWidth":"Classes_fullTableWidth__23LNA","pos_error":"Classes_pos_error__JAS7J"};